import type { AnalysisMode } from './types';

export type EventOnlyAnalysisMode = Extract<AnalysisMode,
  | 'rms-peak-envelope'
  | 'frequency-spectrum'
  | 'calculated-power'
  | 'three-phase-balance'
  | 'time-frequency'
  | 'event-ensemble'
>;

export const EVENT_ONLY_ANALYSIS_MODES = new Set<AnalysisMode>([
  'rms-peak-envelope',
  'frequency-spectrum',
  'calculated-power',
  'three-phase-balance',
  'time-frequency',
  'event-ensemble'
]);

export function isEventOnlyAnalysisMode(mode: AnalysisMode): mode is EventOnlyAnalysisMode {
  return EVENT_ONLY_ANALYSIS_MODES.has(mode);
}
